<template>
  <div class="sm:tw-flex sm:tw-items-center sm:tw-justify-between sm:tw-gap-4">
    <!-- Search Input -->
    <FilesSearchBar
      :model-value="searchValue"
      placeholder="Search by file name, action, or date"
      @update:model-value="updateSearchValue"
    />

    <!-- Filter and Sort -->
    <div class="tw-mt-5 tw-flex tw-w-full tw-gap-4 sm:tw-my-auto md:tw-justify-end">
      <div class="tw-flex-1 md:tw-flex-none">
        <FilesStatusFilter
          class="tw-w-full"
          :selected-status="selectedStatus"
          :status-options="statusOptions"
          @update:selected-status="updateSelectedStatus"
        />
      </div>

      <div class="tw-flex-1 md:tw-flex-none">
        <FilesSortDropdown
          class="tw-w-full"
          :sort-direction="sortDirection"
          @update:sort-direction="updateSortDirection"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ActionRequestStatus } from '@torticity/types'
import debounce from 'lodash/debounce'

const { $analytics } = useNuxtApp()

defineProps<{
  searchValue: string
  selectedStatus: Array<{ code: ActionRequestStatus; name: string }>
  statusOptions: Array<{ code: ActionRequestStatus; name: string }>
  sortDirection: 'asc' | 'desc' | null
}>()

const emit = defineEmits(['update:searchValue', 'update:selectedStatus', 'update:sortDirection'])

const debounceTrackSearch = debounce((value: string) => {
  $analytics.trackElementClicked({ text: value, elementType: 'search' })
}, 500)

function updateSearchValue(value: string) {
  debounceTrackSearch(value)
  emit('update:searchValue', value)
}

function updateSelectedStatus(value: Array<{ code: ActionRequestStatus; name: string }>) {
  $analytics.trackElementClicked({
    text: value.map(s => s.name).join(', '),
    elementType: 'status filter',
  })
  emit('update:selectedStatus', value)
}

function updateSortDirection(value: 'asc' | 'desc') {
  $analytics.trackElementClicked({ text: value, elementType: 'sort by' })
  emit('update:sortDirection', value)
}
</script>
